<template>
    <div class="content" :class="{'invalidContent': isLose}">
        <van-checkbox checked-color='#FF7A45' v-if="!isLose" v-model="good.checked" />
        <div class="checked" v-else><span>失效</span></div>
        <div class="content_img invalidImg" @click="onDetail"><img :src="$viewImageNew(good.skuPictureUrl, 400,400)" alt=""></div>
        <div class="content_right">
            <h3 class="color999" @click="onDetail"><i v-if="good.tags[0] === 3" class="iconfont iconimgs_label_zhangqi" />{{ good.skuShowName }} </h3>
            <div class="content_right_stock" v-if="good.inventoryNum <= 3 && !isLose">库存紧张</div>
            <div class="content_right_num" v-if="good.minimumOrderQuantity > 1 && !isLose">商品最低购买数量为{{ good.minimumOrderQuantity }}</div>
            <div class="content_right_bottom">
                <div class="content_right_bottom_price color999"><span>¥ </span>{{ good.price | NumFormat }}</div>
                <van-stepper :disable-input='true' :min='good.minimumOrderQuantity' :max='getMaxVal()' v-model="good.quantity" @change="sumCartPrice" v-if="!isLose" />
                <span class="disableInput" @click="onInput"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isLose: { // 是否显示失效商品的样式
            type: Boolean,
            default: false
        },
        shop: { // 店铺数据
            type: Object,
            default: () => {
                return {}
            }
        },
        good: { // 商品数组
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    methods: {
        // 触发修改数量的弹窗
        onInput () {
            this.$emit('onDialog')
        },
        // 当绑定的值发生变化触发
        sumCartPrice () {
            this.$emit('sumCartPrice')
        },
        // 跳转商品详情页面
        onDetail () {
            this.$emit('onDetail')
        },
        // 获取最大值
        getMaxVal () {
            let maxVal = 0
            if (this.good.buyLimit) {
                maxVal = this.good.inventoryNum > this.good.orderMaxCount ? this.good.orderMaxCount : this.good.inventoryNum
            } else {
                maxVal = this.good.inventoryNum
            }
            return maxVal
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    padding-right: 24px;
    &.invalidContent {
        margin-bottom: 48px;
        &:last-child {
            margin-bottom: 0;
        }
        .checked {
            display: flex;
            align-items: center;
            padding-left: 8px;
            span {
                display: inline-block;
                width: 72px;
                height: 34px;
                border-radius: 34px;
                font-size: 24px;
                text-align: center;
                color: #fff;
                background: #aaa;
            }
        }
        .invalidImg {
            margin: 0 24px 0 8px;
        }
        .color999 {
            color: #999;
        }
    }
    &_img {
        width: 184px;
        height: 184px;
        margin: 0 24px;
        position: relative;
        display: flex;
        background: #f2f3f5;
        img {
            display: inline-block;
            align-self: center;
            justify-self: center;
            margin: 0 auto;
            object-fit: cover;
        }
    }
    &_right {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        h3 {
            width: 100%;
            color: #333;
            font-weight: 400;
            line-height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
        }
        &_stock {
            width: 100%;
            font-size: 24px;
            color: red;
        }
        &_num {
            position: absolute;
            right: 32px;
            bottom: 55px;
            font-size: 24px;
            color: #ff7a45;
        }
        &_bottom {
            flex: 1;
            line-height: 48px;
            display: flex;
            justify-content: space-between;
            position: relative;
            &_price {
                color: #ff7a45;
                font-size: 30px;
                span {
                    font-size: 20px;
                }
            }
            .disableInput {
                position: absolute;
                top: 0;
                right: 48px;
                width: 56px;
                height: 48px;
            }
        }
    }
}
// 修改组件的样式
/deep/ .van-stepper__minus,
/deep/ .van-stepper__plus {
    width: 48px;
    height: 48px;
}
/deep/ .van-stepper__input {
    width: 56px;
    height: 48px;
    font-size: 24px;
}
// 账期图标的样式
/deep/ .iconimgs_label_zhangqi {
    font-size: 32px;
    vertical-align: middle;
    color: #ff7a45;
    margin-right: 8px;
}
/deep/ .van-stepper__minus::before,
/deep/ .van-stepper__plus::before {
    height: 2px;
}
/deep/ .van-stepper__minus::after,
/deep/ .van-stepper__plus::after {
    width: 2px;
}
</style>
